import { Checkbox, FormControlLabel } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import type {
  PropertyAdAmenityField,
  PropertyAdEditorFormValues,
} from '../../../types/propertyAdEditor';

import checkboxStyles from '../../uiComponents/FormCheckbox/FormCheckbox.module.scss';
import styles from '../PropertyAdEditor.module.scss';

interface EditorCheckboxFieldProps {
  label: string;
  name: PropertyAdAmenityField;
  onValueChange?: (value: boolean) => void;
}

export const EditorCheckboxField = ({ label, name, onValueChange }: EditorCheckboxFieldProps) => {
  const { control } = useFormContext<PropertyAdEditorFormValues>();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <FormControlLabel
          className={`${checkboxStyles.label} ${styles.editorCheckboxField}`}
          control={
            <Checkbox
              checked={field.value}
              checkedIcon={<span className={checkboxStyles.checked} />}
              icon={<span />}
              inputProps={{ 'aria-label': label }}
              inputRef={field.ref}
              name={field.name}
              onBlur={field.onBlur}
              onChange={(_event, checked) => {
                if (onValueChange) {
                  onValueChange(checked);
                  return;
                }

                field.onChange(checked);
              }}
            />
          }
          label={label}
        />
      )}
    />
  );
};
